<div class="row">
	<div class="col-lg-3 col-md-3 col-sm-0"></div>
	<button
		*ngIf="activeStudent"
		class="btn btn-lg btn-primary start mb-2 mt-2 gt-button col-lg-6 col-md-6 col-sm-12"
		(click)="openModal()"
		style="border-color: #555;"
	>
		Record Scores
	</button>
	<div class="col-lg-3 col-md-3 col-sm-0"></div>
</div>
